import './MessageBar.css'

import React from 'react'
import classNames from 'classnames'

export default class MessageBar extends React.Component {
  static getDerivedStateFromProps(props, state) {
    return {
      title: props.title,
      text: props.text,
      buttons: props.buttons || [],
      visible: props.visible !== undefined ? props.visible : state.visible,
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      visible: true,
    }
  }

  _handle(handler) {
    this.setState({ visible: false })
    if (handler) handler()
  }

  render() {
    return this.state.visible ? (
      <div className={classNames('messagebar', this.props.className)}>
        <div className="content">
          <div className="title">{this.state.title}</div>
          <div className="body">{this.state.text}</div>
        </div>
        <div className="buttons">
          {this.state.buttons.map((button, index) => (
            <button
              key={index}
              className="button small"
              onClick={() => this._handle(button.handler)}
            >
              {button.text}
            </button>
          ))}
        </div>
      </div>
    ) : null
  }
}
